"use client"

import { Avatar, AvatarFallback } from "@/components/ui/avatar"
import { Card, CardContent, CardFooter } from "@/components/ui/card"
import { Star } from "lucide-react"
import { useLanguage } from "@/contexts/language-context"

export function Testimonials() {
  const { t } = useLanguage()

  const testimonials = [
    {
      name: t("testimonial1Name"),
      role: t("testimonial1Role"),
      content: t("testimonial1Content"),
      avatar: "L",
    },
    {
      name: t("testimonial2Name"),
      role: t("testimonial2Role"),
      content: t("testimonial2Content"),
      avatar: "W",
    },
    {
      name: t("testimonial3Name"),
      role: t("testimonial3Role"),
      content: t("testimonial3Content"),
      avatar: "Z",
    },
  ]

  return (
    <section className="w-full py-12 md:py-24 bg-muted/30">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center justify-center space-y-4 text-center">
          <div className="space-y-2">
            <h2 className="text-3xl font-bold tracking-tighter sm:text-5xl">{t("testimonialsTitle")}</h2>
            <p className="max-w-[900px] text-muted-foreground md:text-xl">{t("testimonialsDesc")}</p>
          </div>
        </div>
        <div className="mx-auto grid max-w-5xl grid-cols-1 gap-6 py-12 md:grid-cols-3">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-0 bg-background shadow-md">
              <CardContent className="p-6">
                <div className="flex space-x-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="h-4 w-4 fill-amber-500 text-amber-500" />
                  ))}
                </div>
                <p className="text-sm">{testimonial.content}</p>
              </CardContent>
              <CardFooter className="flex items-center space-x-4 border-t px-6 py-4">
                <Avatar>
                  <AvatarFallback>{testimonial.avatar}</AvatarFallback>
                </Avatar>
                <div>
                  <p className="text-sm font-medium">{testimonial.name}</p>
                  <p className="text-xs text-muted-foreground">{testimonial.role}</p>
                </div>
              </CardFooter>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}
